import { Injectable, NgZone } from '@angular/core';
import {Event, NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class MenuServiceService {
  menuItems: Array<any>;
  public currentUrl = new BehaviorSubject<string>(undefined);
  public currentPath = new BehaviorSubject<string>(undefined);
  public freeze_panel_url=new BehaviorSubject<boolean>(false);

  constructor(
    private _zone: NgZone,
    private router: Router
  ) {

    this.menuItems = [];
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }

  addMenu(items: Array<{
      text: string,
      heading?: boolean,
      link?: string,     // internal route links
      elink?: string,    // used only for external links
      target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
      icon?: string,
      alert?: string,
      submenu?: Array<any>
  }>) {
    items && items.forEach((item) => {
      this.menuItems.push(item);
    });
  }

  resetMenu() {
    this._zone.run(_ => {
        this.menuItems = [];
    });
  }

  getMenu() {

    const [user] = JSON.parse(localStorage.getItem('userProfileData') || '[]') || [];

    if(!user?.terminal_flow_enabled) {
      // Menu items hidden until the terminal flow is enabled for the user.
      const hiddenPaths = ['/app/manage-terminal', '/app/customer/customer-unified'];
      const filteredItems = this.menuItems.filter(item => !hiddenPaths.includes(item?.path));
      return filteredItems;
    }

      return this.menuItems;
  }

}
